import { useFilterOptions } from './useFiltersOptions';
import sortOptions from '@/constants/sortOptions';

export const useDispatchedFilterStore = useFilterOptions(
  'dispatchedFilterStore',
  'api/transport-requests/manage/Accepted',
  {
    sortObj: sortOptions.dispatchedDate
  }
);
